import { postCrearItemExtra, updateAutorizacionCompraItem } from "../services/comprasService"
import { getExtrasAprobadosAgente, getExtrasAprobadosAgenteVersion } from "../services/serviceViaje"
const dataInicial = {
    listExtrasContratados: [],
    busqueda: 'NA',
    exito: 0,
    pagina: 0,
    registros: 10,
    total: 0,
    version: 1
}
const OBTENER_EXTRAS_CONTRATADOS_ALL_ACTION = "OBTENER_EXTRAS_CONTRATADOS_ALL_ACTION"
const OBTENER_EXTRAS_CONTRATADOS_PAGINA_ACTION = "OBTENER_EXTRAS_CONTRATADOS_PAGINA_ACTION"
const OBTENER_EXTRAS_CONTRATADOS_REGISTROS_ACTION = "OBTENER_EXTRAS_CONTRATADOS_REGISTROS_ACTION"
const OBTENER_EXTRAS_CONTRATADOS_BUSQUEDA_ACTION = "OBTENER_EOBTENER_EXTRAS_CONTRATADOS_BUSQUEDA_ACTIONXTRAS_CONTRATADOS_ALL_ACTION"
const POST_EXTRAS_CONTRATADOS_NUEVO_ITEM = "POST_EXTRAS_CONTRATADOS_NUEVO_ITEM"
const PUT_EXTRAS_CONTRATADOS_ENVIAR_FINANZAS = "PUT_EXTRAS_CONTRATADOS_ENVIAR_FINANZAS"
const OBTENER_EXTRAS_CONTRATADOS_VERSION_ACTION = "OBTENER_EXTRAS_CONTRATADOS_VERSION_ACTION"
//* Metodos para extras contratados
export default function extrasContratadosReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_EXTRAS_CONTRATADOS_VERSION_ACTION:
            return { ...state, listExtrasContratados: action.payload.listExtrasContratados, total: action.payload.total, version: action.payload.version }
        case OBTENER_EXTRAS_CONTRATADOS_BUSQUEDA_ACTION:
            return { ...state, listExtrasContratados: action.payload.listExtrasContratados, total: action.payload.total, registros: action.payload.registros, pagina: action.payload.pagina }
        case OBTENER_EXTRAS_CONTRATADOS_REGISTROS_ACTION:
            return { ...state, listExtrasContratados: action.payload.listExtrasContratados, total: action.payload.total, registros: action.payload.registros }
        case OBTENER_EXTRAS_CONTRATADOS_PAGINA_ACTION:
            return { ...state, listExtrasContratados: action.payload.listExtrasContratados, total: action.payload.total, pagina: action.payload.pagina }
        case OBTENER_EXTRAS_CONTRATADOS_ALL_ACTION:
            return { ...state, listExtrasContratados: action.payload.listExtrasContratados, total: action.payload.total }
        case POST_EXTRAS_CONTRATADOS_NUEVO_ITEM:
            return { ...state, exito: action.payload.exito }
        case PUT_EXTRAS_CONTRATADOS_ENVIAR_FINANZAS:
            return { ...state, exito: action.payload.exito }
        
        default:
            return state
    }
}
export const obtenerExtrasContratadosVersionAction = ({version}) => async (dispatch, getSate) => {
    const { busqueda, pagina, registros } = getSate().extrasContratados
    return await getExtrasAprobadosAgenteVersion({ Referencia: busqueda, Pagina: pagina + 1, Registros: registros, IdCatVersionPaquete: version }).then(Response => {
        dispatch({
            type: OBTENER_EXTRAS_CONTRATADOS_VERSION_ACTION,
            payload: {
                listExtrasContratados: Response?.lExtra,
                total: Response?.total,
                version: version
            }
        })
        return Response

    }).catch(Error => {
        return Error
    })
}
export const enviarItemExtraAction = ({ idCompra }) => async (dispatch) => {
    return await updateAutorizacionCompraItem({ idCompra }).then(Response => {
        dispatch({
            type: PUT_EXTRAS_CONTRATADOS_ENVIAR_FINANZAS,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const crearItemExtraAction = ({ idCuenta, IdExtra, idMoneda, idPaquete, MontoProveedor }) => async (dispatch) => {
    return await postCrearItemExtra({ idCuenta, IdExtra, idMoneda, idPaquete, MontoProveedor }).then(Response => {
        dispatch({
            type: POST_EXTRAS_CONTRATADOS_NUEVO_ITEM,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerExtrasContratadosAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros, version } = getSate().extrasContratados
    return await getExtrasAprobadosAgenteVersion({ Referencia: busqueda, Pagina: pagina + 1, Registros: registros, IdCatVersionPaquete: version }).then(Response => {
        dispatch({
            type: OBTENER_EXTRAS_CONTRATADOS_ALL_ACTION,
            payload: {
                listExtrasContratados: Response?.lExtra,
                total: Response?.total
            }
        })
        return Response

    }).catch(Error => {
        return Error
    })
}
export const obtenerExtrasContratadosPaginaAction = ({ pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros, version } = getSate().extrasContratados
    return await getExtrasAprobadosAgenteVersion({ Referencia: busqueda, Pagina: pagina + 1, Registros: registros, IdCatVersionPaquete: version }).then(Response => {
        dispatch({
            type: OBTENER_EXTRAS_CONTRATADOS_PAGINA_ACTION,
            payload: {
                listExtrasContratados: Response?.lExtra,
                total: Response?.total,
                pagina: pagina
            }
        })
        return Response

    }).catch(Error => {
        return Error
    })
}
export const obtenerExtrasContratadosRegistrosAction = ({ registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina, version } = getSate().extrasContratados
    return await getExtrasAprobadosAgenteVersion({ Referencia: busqueda, Pagina: pagina + 1, Registros: registros, IdCatVersionPaquete: version}).then(Response => {
        dispatch({
            type: OBTENER_EXTRAS_CONTRATADOS_REGISTROS_ACTION,
            payload: {
                listExtrasContratados: Response?.lExtra,
                total: Response?.total,
                registros: registros
            }
        })
        return Response

    }).catch(Error => {
        return Error
    })
}
export const obtenerExtrasContratadosBusquedaAction = ({ busqueda }) => async (dispatch, getSate) => {
    const { registros, pagina, version } = getSate().extrasContratados
    return await getExtrasAprobadosAgenteVersion({ Referencia: busqueda, Pagina: pagina + 1, Registros: registros, IdCatVersionPaquete: version }).then(Response => {
        dispatch({
            type: OBTENER_EXTRAS_CONTRATADOS_BUSQUEDA_ACTION,
            payload: {
                listExtrasContratados: Response?.lExtra,
                total: Response?.total,
                pagina: dataInicial.pagina,
                registros: dataInicial.registros
            }
        })
        return Response

    }).catch(Error => {
        return Error
    })
}